import React, {CSSProperties} from "react";
import * as flagStrings from "country-flag-icons/string/3x2";
import flagEmojiToCountryCode from "tools/flags/flagEmojiToCountryCode";

const flagSvgByCode = (flagStrings as unknown) as Record<string, string>;

type CountryFlagProps = {
  flagEmoji?: string;
  width?: number;
  className?: string;
  size?: "small" | "medium";
};

const CountryFlag = ({
  flagEmoji,
  width = 20,
  className,
  size = "medium",
}: CountryFlagProps) => {
  const code = flagEmojiToCountryCode(flagEmoji);
  const svg = code ? flagSvgByCode[code] : undefined;

  if (!svg) return null;

  const isSmall = size === "small";

  const dimensions: CSSProperties = {
    width: isSmall ? 15 : 24,
    height: isSmall ? 12 : 18,
  };

  return (
    <img
      src={`data:image/svg+xml,${encodeURIComponent(svg)}`}
      alt=""
      className={className}
      style={{
        display: "inline-block",
        verticalAlign: "middle",
        borderRadius: 4,
        ...dimensions,
      }}
    />
  );
};

export default CountryFlag;
